import { ChevronDownIcon } from '@primer/octicons-react';
import { Button, SelectPanel } from '@primer/react';
import { useMemo, useState } from 'react';

export interface ISelectBoxSingleItem {
    id: string | number;
    text: string;
}

type SelectBoxSingleProps = {
    items: ISelectBoxSingleItem[];
    value?: string | number | null;
    onValueChanged: (value: string | number | undefined) => void;
    title?: string;
    placeholder?: string;
    disabled?: boolean;
    width?: string | number;
};

const removeVietnameseTones = (str: string) => {
    return str
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/đ/g, 'd')
        .replace(/Đ/g, 'D');
};

const SelectBoxSingle = (props: SelectBoxSingleProps) => {
    const [open, setOpen] = useState(false);
    const [filter, setFilter] = useState('');

    const selectedItem = useMemo(
        () => props.items.find(x => x.id === props.value),
        [props.items, props.value]
    );

    const filteredItems = useMemo(() => {
        const keyword = removeVietnameseTones(filter.trim().toLowerCase());
        if (!keyword) return props.items;
        return props.items.filter(x => removeVietnameseTones(x.text.toLowerCase()).includes(keyword));
    }, [props.items, filter]);

    return (
        <SelectPanel
            renderAnchor={({ children, 'aria-labelledby': ariaLabelledBy, ...anchorProps }) => (
                <Button
                    trailingAction={ChevronDownIcon}
                    aria-labelledby={` ${ariaLabelledBy}`}
                    {...anchorProps}
                    disabled={props.disabled}
                    sx={{
                        width: props.width ?? '100%',
                        minWidth: 0,
                        overflow: 'hidden',
                        '[data-component="buttonContent"]': {
                            display: 'flex',
                            justifyContent: 'flex-start',
                            gridTemplateAreas: 'none',
                            gridTemplateColumns: 'none',
                            minWidth: 0,
                            overflow: 'hidden',
                            '& > :first-child': {
                                flex: 1,
                                minWidth: 0,
                                textAlign: 'left',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                            },
                        },
                    }}
                >
                    {selectedItem?.text ?? props.placeholder ?? 'Chọn'}
                </Button>
            )}
            title={props.title ?? props.placeholder ?? ''}
            placeholderText='Search'
            open={open}
            onOpenChange={setOpen}
            items={filteredItems}
            selected={selectedItem}
            onFilterChange={setFilter}
            onSelectedChange={(item: any) => props.onValueChanged(item ? item.id : undefined)}
            showItemDividers={true}
            overlayProps={{ width: 'large', height: 'medium' }}
        />
    );
};

export default SelectBoxSingle;
